
import { computed, getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'
import api from '@/api/api'
import { CONNECTOR_TYPES } from '@/vars/general'
import { saveCredentials } from '@api/connectors/arnicaV2'

const TASKS = [
    {
        title: 'Проверьте права аккаунта',
        body: 'Нужен аккаунт с правами владельца.',
    },
    {
        title: 'Введите логин и пароль',
        body: 'Данные нужны для первичного подключения интеграции.',
    },
    {
        title: 'Отправьте на проверку',
        body: 'Data Heroes проверит подключение и доступность данных.',
    },
]

export default {
    name: 'ArnicaV2Auth',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const loading = ref(false)
        const credentials = ref({
            login: '',
            password: '',
            isKlinika: false,
        })

        const btnDisabled = computed(
            () =>
                !String(credentials.value.login || '').trim() ||
                !String(credentials.value.password || '').trim()
        )

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const submitLogin = async () => {
            loading.value = true
            syncWizardNav()

            const projectId = root.$router.currentRoute.params.id
            const pendingConnectors = await api.project.getPendingConnectorsByProject({
                projectId,
            })
            const pendingConnector = pendingConnectors.data[0]
            const connector =
                pendingConnector ??
                (await store.dispatch('project/createConnector', {
                    projectId,
                    connectorType: CONNECTOR_TYPES.arnicaV2,
                }))
            await saveCredentials(connector, credentials.value)

            store.commit('project/setLoggedAddingConnector', connector)
            if (pendingConnector) {
                root.$parent.$emit('next')
            } else {
                root.$parent.$emit('login')
            }
            loading.value = false
            syncWizardNav()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: !btnDisabled.value,
                nextLoading: loading.value,
                nextLabel: 'Далее',
                onBack: goBackToCrm,
                onNext: submitLogin,
            }),
            [loading, btnDisabled]
        )

        return {
            tasks: TASKS,
            credentials,
            loading,
            btnDisabled,
            hasWizardNav,
            goBackToCrm,
            submitLogin,
        }
    },
}
